import {IdObjectsWithId} from "../../../utils";
import {IVariablesFormFields} from "../../../components/BannerEditor/VariablesForm";

export enum VariablesType {
    DESIGN = "DESIGN",
    FEED = "FEED"
}

export interface IBannerVariables {
    id: string;
    parentId?: string;
    variablesType: VariablesType;
    isMaster?: boolean;
    name: string;
    variables: IVariablesFormFields | null
    created: Object;
    updated: Object;
}

export interface IBannerVariablesState {
    readonly bannerVariables: IdObjectsWithId<IBannerVariables>;
    readonly activeDesignBannerVariables: IBannerVariables;
    readonly activeMasterDesignBannerVariables: IBannerVariables;
    readonly activeFeedBannerVariables: IBannerVariables;
    readonly activeMasterFeedBannerVariables: IBannerVariables;
    readonly isLoading: boolean;
}


